/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./preview-template-button.vue?vue&type=template&id=6e0ae0a8&scoped=true&"
import script from "./preview-template-button.vue?vue&type=script&lang=js&"
export * from "./preview-template-button.vue?vue&type=script&lang=js&"
import style0 from "./preview-template-button.vue?vue&type=style&index=0&id=6e0ae0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0ae0a8",
  null
  
)

export default component.exports